import { v4 as uuidv4 } from 'uuid';
import FinancialSecurityGridPluginSettings from './FinancialSecurityGridPluginSettings';
import FinancialSecurityGrid from './FinancialSecurityGrid';

export const FinancialSecurityTab = (): ITab => {
    return {
        id: uuidv4(),
        title: 'Код финансового обеспечения',
        view: {
            content:    FinancialSecurityGridPluginSettings 
                        ? <FinancialSecurityGrid gridId={uuidv4()} plugin={FinancialSecurityGridPluginSettings} />
                        : <p> Справочник не настроен </p>
        }
    }
}

export default FinancialSecurityTab